module.exports = __webpack_public_path__ + "img/117.7.35cc785c.png";